export const meta = {
  slug: { de: "digitale-terminvergabe-praxis-vorteile", en: "digital-appointment-scheduling-benefits" },
  title: "Digitale Terminvergabe in der Praxis: konkrete Vorteile im Alltag",
  excerpt:
    "Digitale Terminvergabe entlastet eine Praxis nur dann, wenn sie sauber in den Alltag eingebettet ist. Dann wirkt sie ruhig und verlässlich.",
  category: "praxen",
  publishedAt: "2026-04-10",
  updatedAt: "2026-05-06",
  metaTitle: "Digitale Terminvergabe für Praxen | OnePractix",
  metaDescription:
    "Welche konkreten Vorteile eine digitale Terminvergabe für Praxen bringt – und worauf zu achten ist, damit sie im Alltag wirklich entlastet.",
  related: ["online-terminbuchung-wann-sinnvoll", "terminabsagen-reduzieren-praxis"],
  en: {
    title: "Digital appointment scheduling in the practice: concrete benefits in everyday work",
    metaTitle: "Digital appointment scheduling benefits | OnePractix",
    metaDescription:
      "Concrete benefits digital appointment scheduling brings to a practice — and what to consider so it actually relieves daily work.",
    excerpt:
      "Digital appointment scheduling only relieves a practice when it is cleanly embedded in everyday work. Then it works calmly and reliably.",
  },
};

export default meta;
